// extracted by mini-css-extract-plugin
export var closeButton = "_2u-3";
export var header = "_2u-0";
export var link = "_2u-1";
export var retryButton = "_2u-2";